export default class CaseInsensitiveStringComparer {
    compare(x, y) {
        return x.localeCompare(y, undefined, { sensitivity: 'accent' });
    }
    equals(x, y) {
        return this.compare(x, y) === 0;
    }
    greaterThan(x, y) {
        return this.compare(x, y) > 0;
    }
    greaterThanOrEqual(x, y) {
        return this.compare(x, y) >= 0;
    }
    lessThan(x, y) {
        return this.compare(x, y) < 0;
    }
    lessThanOrEqual(x, y) {
        return this.compare(x, y) <= 0;
    }
}
